import https from "@/utils/https"
import {Method} from 'axios-mapper'
import {Root} from "@/models/root";
import {Course, UserCourse} from "@/models/course/course";
import {CoursePlan} from "@/models/course/coursePlan";
import {CoursePlanPart, UserCoursePlanPart} from "@/models/course/coursePlanPart";
import {CourseLiveVO} from "@/apis/live";

export interface CoursePlanPartVO extends CoursePlanPart {
  courseLiveVO?: CourseLiveVO;
  userCoursePlanPart: UserCoursePlanPart;
  show?: boolean
}

export interface CoursePlanVO extends CoursePlan {
  parts: CoursePlanPartVO[];
  show?: boolean
}

export interface CourseVO extends Course {
  userCourse: UserCourse;
  plans: CoursePlanVO[];
}

/**
 * 获取用户课程
 * @param courseId
 */
export const fetchUserCourse = (courseId: number): Promise<Root<CourseVO> | null> => {
  return https(true).request<Root<CourseVO>>(`/course/user/course/${courseId}`, Method.GET)
}
